import React from 'react';
import PropTypes from 'prop-types';
import { Copy, Optional, Icon, IconWrapper } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './styles/NoticeCard.styles';
import { campaignStatus } from '../../utils/constants';
import useConfiguration from '../../hooks/useConfiguration';
import componentConfig from './componentConfig';

const UpdateText = themeStyles.apply(Copy, 'UpdateText');
const ServiceText = themeStyles.apply(Copy, 'ServiceText');

const NoticeUpdate = ({ status, servicedOn, noticeUpdates, serviceText, isPartsAvailable }) => {
  const { counterColour, noUpdateIconName, noUpdateIconFilled, noUpdateIcon } = useConfiguration(componentConfig);
  const { t } = useTranslation();

  return status === campaignStatus.ongoing ? (
    <Optional when={status === campaignStatus.ongoing}>
      <Optional when={!isPartsAvailable}>
        <IconWrapper size="14px" mr={2}>
          <Icon
            filled={noUpdateIconFilled}
            name={noUpdateIconName}
            title={t('additionalInformation')}
            iconColor={noUpdateIcon}
          />
        </IconWrapper>
      </Optional>
      <UpdateText counterColour={counterColour}>{noticeUpdates}</UpdateText>
    </Optional>
  ) : (
    <Optional when={servicedOn}>
      <Copy size="small">
        {serviceText}
        <ServiceText as="span" data-testid="cy-service-date">
          {servicedOn}
        </ServiceText>
      </Copy>
    </Optional>
  );
};

NoticeUpdate.propTypes = {
  status: PropTypes.string,
  servicedOn: PropTypes.string,
  noticeUpdates: PropTypes.string,
  serviceText: PropTypes.string,
  isPartsAvailable: PropTypes.bool,
};

export default NoticeUpdate;
